import { IconArrowRight, IconMenu2 } from '@tabler/icons-react';
import logo2 from '../assets/logo_Ys_Transparent.png';

import { BButton } from './ui/generic';
import { getCurrentUser } from '../utils/Sessions';
import { useHeader } from '../context/HeaderContext';
import React, { useEffect, useState } from 'react';
import BDrawer from './BDrawer';
import BSidebar from './BSidebar';
import { useLocation } from 'react-router';

const Header = () => {
  const location = useLocation();
  const [showMenu, setShowMenu] = useState(false);
  useEffect(() => {
    setShowMenu(false);
  }, [location.pathname]);

  const user = getCurrentUser();
  const { title, description } = useHeader();

  return (
    <div className={`flex h-[100px] w-full items-center justify-between px-6`}>
      <BDrawer open={showMenu} setOpen={setShowMenu}>
        <BDrawer.Header>
          <img src={logo2} alt="Logo" className="block w-fit md:hidden" />
        </BDrawer.Header>
        <BDrawer.Body>
          <BSidebar />
        </BDrawer.Body>
      </BDrawer>
      <div>
        <img src={logo2} alt="Logo" className="block w-40 md:hidden" />

        <h2 className={'text-sm font-normal text-slate-400'}>
          {description || 'Bienvenue dans votre portail client YouSchool'}
        </h2>
      </div>
      {user.is_client && (
        <form target="_blank" action={'https://youschool.io/login'} className={'flex gap-5'}>
          <BButton type={'submit'} icon={IconArrowRight} color={'alternative'} label={'Accéder à la plateforme'} />
        </form>
      )}
      <button className={'text-slate-700 md:hidden'} type={'button'} onClick={() => setShowMenu(!showMenu)}>
        <IconMenu2 className={'size-8'} />
      </button>
    </div>
  );
};

export default Header;
